import { ActionTree } from 'vuex'
import { IAdminState } from './types'
import { getAdminList } from '@/apps/open/services/admin'
import store from '@/apps/open/store'

const actions: ActionTree<IAdminState, any> = {
  GET_ADMIN_LIST: async ({ commit }) => {
    try {
      const curEnterprise = store.getters['User/curEnterprise']
      const params = {
        developer_id: curEnterprise.developer_id
      }
      const res = await getAdminList(params)
      const adminList = res.data.object_array
      commit('SET_ADMIN_LIST', adminList)
      return Promise.resolve(adminList)
    } catch (error) {
      commit('SET_ADMIN_LIST')
      return Promise.reject(error)
    }
  }
}

export default actions
